export default __webpack_public_path__ + "static/media/ouro.6dd2d399.png";